/* eslint-disable no-prototype-builtins */
/* eslint-disable no-constant-condition */
/* eslint-disable no-cond-assign */
/* eslint-disable no-shadow */
/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-restricted-syntax */
/* eslint-disable prefer-destructuring */
/* eslint-disable react/jsx-props-no-spreading */
import queryString from "query-string";
import React, { useContext, useEffect, useRef, useState } from "react";
import { Box, Button as MuiButton, TextField } from "@mui/material";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import moment from "moment/moment";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Helmet } from "react-helmet";
import EmptyFileIcon from "../../../assets/svg/EmptyFile";
import ReloadIcon from "../../../assets/svg/ReloadIcon";
import AppliedFilter from "../../../components/common/AppliedFilter/AppliedFilter";
import Loader from "../../../components/common/Loader/Loader";
import Modal from "../../../components/common/Modal/Modal";
import useUserConfig from "../../../hooks/useUserConfig";
import {
  AppliedFilterLabelMap,
  DATES,
  EVENT_NAME,
  Constants,
  AlertStatus,
} from "../../../contants";
import useParamsQuery from "../../../hooks/useParamsQuery";
import { selectOSKeysByUserRole } from "../../../redux/selectors/user";
import Reports from "../../../services/api/reports";
import { ROUTES } from "../../../utils/constants";
import { formDataToObject, isEmptyObj } from "../../../utils/helper";
import styles from "./StatsSearch.styles";
import { getFilters, getFormattedQuery, handleDependencyFilter } from "./utils";
import { ToastAlertContext } from "../../../config/providers/ToastAlert";
import ReportTable from "./ReportsTable/CurrentStatsTable";
import OrganizationSearchWrapper from "./OrganizationSearchReports";
import Toast from "../../../components/common/Toast";

const LOADER_DELAY = 1000;
const PAGE = "page";

const filterOrder = [
  "areaId",
  "clusterId",
  "zoneId",
  "regionId",
  "chapterId",
  "districtId",
];

export const getRoutePath = () => ROUTES.REPORTS_CURRENT_STATS.path;

const initialFormValue = {
  from: "",
};

function StatsReports() {
  const TITLE = "Current Stats Report - BSG";
  const [searchData, setSearchData] = useState([]);
  const [appliedFilters, setAppliedFilters] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [openResultModal, setOpenResultModal] = useState(false);
  const [showSearchResult, setShowSearchResult] = useState(false);
  const allowModalRef = useRef(false);
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < 768 : false
  );

  const formRef = useRef(null);
  const navigate = useNavigate();
  const metaData = useSelector((state) => state.meta);
  const disabledOSKeys = useSelector(selectOSKeysByUserRole);
  const hasPermission = useUserConfig();
  const { getQueryObject, getQueryParams, urlSearchParams } = useParamsQuery();
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(Constants.DEFAULT_PAGE_SIZE);
  const toast = useContext(ToastAlertContext);
  const [dateFrom, setDateFrom] = useState(initialFormValue.from);
  const [dateValue, setDateValue] = useState(null);
  const [showToast, setShowToast] = useState(null);

  const isCurrentMonthSelected = () => {
    const queryObject = getQueryObject();
    const formattedQuery = getFormattedQuery({
      ...queryObject,
    });

    const from = formattedQuery?.from;
    if (!from) return false;

    const currentMonthFrom = moment().startOf("month").format("YYYY-MM-DD");
    return String(from) === String(currentMonthFrom);
  };

  useEffect(() => {
    const onResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const handleDateChange = (newValue) => {
    if (newValue !== null) {
      const newDateValue = new Date(newValue);
      const selectedDate = moment(newDateValue);
      const firstDayOfMonth = selectedDate.clone().startOf("month");
      const localFirstDayOfMonth = moment(firstDayOfMonth).format("YYYY-MM-DD");

      setDateFrom(localFirstDayOfMonth);
    } else {
      setDateFrom("");
    }

    setDateValue(newValue);
  };

  const clearFormRef = () => {
    Object.keys(AppliedFilterLabelMap).forEach((key) => {
      if (formRef.current[key]) {
        formRef.current[key].value = "";
        formRef.current[key]?.blur();
      }
    });
  };

  const resetFormState = () => {
    setSearchData([]);
    setAppliedFilters([]);
    clearFormRef();
    setDateFrom("");
    setDateValue(null);
  };

  const initializeFormState = (queryObject) => {
    if (!isEmptyObj(queryObject)) {
      clearFormRef();
      Object.keys(queryObject).forEach((key) => {
        if (formRef.current[key]) {
          formRef.current[key].value = queryObject[key];
        }
      });
    }
  };

  const updateSearchParam = (query) => {
    if (query?.length) {
      navigate(`${getRoutePath()}?${query}`);
    } else {
      navigate(`${getRoutePath()}`);
    }
  };

  const removeKeyFromQuery = (queryObject, filterKey) => {
    let updatedQuery = {
      ...queryObject,
    };

    if (DATES.includes(filterKey)) {
      delete updatedQuery[filterKey];
      delete updatedQuery[`${filterKey.split("From")[0]}To`];
    } else {
      delete updatedQuery[filterKey];
    }

    if (Object.keys(updatedQuery).length === 1 && PAGE in updatedQuery) {
      delete updatedQuery[PAGE];
    }

    updatedQuery = handleDependencyFilter(updatedQuery, disabledOSKeys);

    return updatedQuery;
  };

  const onRemoveFilter = (filterKey) => {
    let queryObject = getQueryObject();
    queryObject = removeKeyFromQuery(queryObject, filterKey);
    const updatedQuery = queryString.stringify(queryObject);
    updateSearchParam(updatedQuery);
    clearFormRef();
  };

  const hasAnyRealFilter = (q) => {
    if (!q || isEmptyObj(q)) return false;
    return Object.entries(q).some(
      ([k, v]) =>
        !["pageNumber", "pageSize"].includes(k) &&
        v !== undefined &&
        String(v).trim() !== ""
    );
  };

  const validateAndFetchData = (formattedQuery, toastCtx, setLoading) => {
    if (
      ((!formattedQuery.hasOwnProperty("from") || formattedQuery.from === "") &&
        !formattedQuery.hasOwnProperty("to")) ||
      formattedQuery.to === ""
    ) {
      toastCtx.show("Please select month", AlertStatus.ERROR);
      setLoading(false);
      return false;
    }

    return true;
  };

  const fetchSearchData = async (queryParams) => {
    try {
      setIsLoading(true);
      const formattedQuery = getFormattedQuery({
        ...queryParams,
      });

      if (validateAndFetchData(formattedQuery, toast, setIsLoading)) {
        const response = await Reports.GetStatsReports(formattedQuery);
        if (response.code === 200 && response.message === "") {
          setIsLoading(false);
        }

        const { data } = response;

        setTimeout(() => {
          setSearchData(data);
          setCurrentPage(data?.number);
          setPageSize(pageSize);
          setIsLoading(false);

          if (data?.length > 0) {
            if (allowModalRef.current) {
              setOpenResultModal(true);
              setShowSearchResult(true);
              allowModalRef.current = false;
            }
          } else {
            setShowToast({
              severity: "error",
              message: "No data found",
            });
            setOpenResultModal(false);
            setShowSearchResult(false);
            allowModalRef.current = false;
          }
        }, LOADER_DELAY);
      }
    } catch (error) {
      setIsLoading(false);
      toast.show(
        error.message || "Something went wrong. Please contact support.",
        AlertStatus.ERROR
      );
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();

    const rawFormData = new FormData(formRef.current);
    const formData = formDataToObject(rawFormData);

    if (dateFrom !== "") {
      formData.from = dateFrom;
    }

    const hasFilter = Object.values(formData).some(
      (val) => val && String(val).trim() !== ""
    );
    if (!hasFilter) {
      setShowToast({
        severity: "warning",
        message: "Please select your search filter",
      });
      return;
    }

    const query = queryString.stringify(formData);

    document.dispatchEvent(new Event(EVENT_NAME));

    allowModalRef.current = true;

    updateSearchParam(query);
    fetchSearchData(formData);
  };

  useEffect(() => {
    const queryObject = getQueryObject();

    if (isEmptyObj(queryObject)) {
      resetFormState();
      setOpenResultModal(false);
      setShowSearchResult(false);
      allowModalRef.current = false;
      return;
    }

    if (!hasAnyRealFilter(queryObject)) {
      resetFormState();
      setOpenResultModal(false);
      setShowSearchResult(false);
      allowModalRef.current = false;
      if (
        queryObject.pageNumber !== undefined ||
        queryObject.pageSize !== undefined
      ) {
        updateSearchParam();
      }
      return;
    }

    const [query] = getQueryParams(queryObject);
    fetchSearchData(query);
    initializeFormState(query);
  }, [urlSearchParams.toString()]);

  useEffect(() => {
    const queryObject = getQueryObject();
    if (
      !isEmptyObj(queryObject) &&
      metaData &&
      disabledOSKeys &&
      hasAnyRealFilter(queryObject)
    ) {
      const query = getQueryParams(queryObject)[0];
      try {
        setAppliedFilters(getFilters(query, metaData, disabledOSKeys));
      } catch (err) {
        console.error("Error in getFilters:", err);
        setAppliedFilters([]);
      }
    } else {
      setAppliedFilters([]);
    }
  }, [metaData, disabledOSKeys, urlSearchParams.toString()]);

  const onRefresh = () => {
    const queryObject = getQueryObject();
    const [query] = getQueryParams(queryObject);
    fetchSearchData(query);
  };

  const onDownloadReport = async () => {
    try {
      const queryObject = getQueryObject();
      const formattedQuery = getFormattedQuery({
        ...queryObject,
      });

      // OLD: clusterId was not being sent in download payload, so downloaded report could ignore cluster filter.
      // const payload = {
      //   areaId: formattedQuery.areaId || null,
      //   zoneId: formattedQuery.zoneId || null,
      //   regionId: formattedQuery.regionId || null,
      //   chapterId: formattedQuery.chapterId || null,
      //   districtId: formattedQuery.districtId || null,
      //   blockId: formattedQuery.blockId || null,
      //   from: formattedQuery.from || null,
      //   to: formattedQuery.to || null,
      // };

      const payload = {
        areaId: formattedQuery.areaId || null,
        clusterId: formattedQuery.clusterId || null,
        zoneId: formattedQuery.zoneId || null,
        regionId: formattedQuery.regionId || null,
        chapterId: formattedQuery.chapterId || null,
        districtId: formattedQuery.districtId || null,
        blockId: formattedQuery.blockId || null,
        from: formattedQuery.from || null,
        to: formattedQuery.to || null,
      };

      const response = await Reports.downloadConnectionStatsReport({
        data: payload,
      });

      if (response.code === 200) {
        const { name } = response.data;
        toast.show(
          `${name} will be available shortly under downloads`,
          AlertStatus.SUCCESS
        );
      }
    } catch (error) {
      toast.show(
        error.message || "Something went wrong. Please contact support.",
        AlertStatus.ERROR
      );
    }
  };

  const handleGoBackToSearch = () => {
    setOpenResultModal(false);
    setShowSearchResult(false);
    allowModalRef.current = false;
  };

  const handleResetAndClose = () => {
    resetFormState();
    updateSearchParam();
    setShowSearchResult(false);
    setOpenResultModal(false);
    allowModalRef.current = false;
  };

  const orderedFilters = filterOrder
    .map((filterKey) =>
      appliedFilters.find((filter) => filter.key === filterKey)
    )
    .filter(Boolean);

  const additionalFilters = appliedFilters.filter(
    (filter) => !filterOrder.includes(filter.key)
  );

  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>

      <div style={styles.container}>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "1px",
          }}
        >
          <MuiButton
            onClick={handleResetAndClose}
            variant="outlined"
            color="secondary"
            sx={{
              textTransform: "none",
              height: "20px",
              fontSize: "13px",
              fontWeight: "600",
              marginRight: "10px",
              width: "85px",
              padding: "0px !important",
            }}
          >
            Clear Filters
          </MuiButton>
        </div>

        {/* Search Form */}
        <div style={styles.filter}>
          <form
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "8px",
              width: "100%",
            }}
            onSubmit={onSubmit}
            ref={formRef}
          >
            {/* Organization Structure */}
            {dateValue && (
              <div>
                <div style={{ fontWeight: "600", marginBottom: "8px" }}>
                  Organization Structure
                </div>

                <OrganizationSearchWrapper
                  disabledOSKeys={disabledOSKeys}
                  selectedDate={dateValue} // 🔥 important
                />
              </div>
            )}

            <Box
              sx={{
                width: isMobile ? "80%" : "25%",
                "& .MuiInputBase-root": {
                  height: "40px !important",
                  borderRadius: "8px",
                },
                "& .MuiInputLabel-root": {
                  fontSize: "14px !important",
                },
                "& .MuiInputLabel-shrink": {
                  top: "0px !important",
                },
                "& .MuiOutlinedInput-input": {
                  padding: "8.5px 14px !important",
                  fontSize: "14px",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderRadius: "8px",
                },
                "& .MuiInputBase-input": {
                  height: "auto !important",
                  padding: "8.5px 14px !important",
                },
              }}
            >
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Select Month"
                  views={["year", "month"]}
                  name="month"
                  value={dateValue}
                  disableFuture
                  onChange={handleDateChange}
                  renderInput={(params) => (
                    <TextField {...params} size="small" fullWidth />
                  )}
                />
              </LocalizationProvider>
            </Box>

            <div
              style={{
                alignSelf: "end",
                marginTop: "10px",
                marginRight: "5px",
                marginBottom: isMobile ? "50px" : "0px",
              }}
            >
              <MuiButton type="submit" variant="contained" color="primary">
                Search
              </MuiButton>
            </div>
          </form>
        </div>

        {isLoading && <Loader />}

        {/* Search Results Modal */}
        <Modal
          open={openResultModal}
          onClose={handleGoBackToSearch}
          title="Search Results"
          customStyle={{
            marginTop: "30px",
            width: "98%",
            maxWidth: "100%",
            height: "90%",
            maxHeight: "100%",
            overflowY: "auto",
            backgroundColor: "#fff",
            display: "flex",
            flexDirection: "column",
            padding: "10px",
            position: "relative",
          }}
        >
          {isLoading ? (
            <Loader />
          ) : searchData.length > 0 ? (
            <>
              {/* Header Row */}
              <div
                style={{
                  display: "flex",
                  flexDirection: isMobile ? "column" : "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  flexWrap: "wrap",
                  gap: "10px",
                  fontWeight: 600,
                  fontSize: 13,
                  marginBottom: "0px",
                  paddingBottom: "0px",
                  borderBottom: "1px solid #eee",
                }}
              >
                {/* Left: Total + Filters */}
                <div
                  style={{
                    display: "flex",
                    flex: 1,
                    minWidth: 260,
                    gap: 10,
                    alignItems: "center",
                    flexWrap: "wrap",
                  }}
                >
                  <div style={{ flex: "0 0 auto" }}>
                    Total Records: {searchData?.length || 0}
                  </div>
                  {appliedFilters.length > 0 && (
                    <div style={{ flex: 1, minWidth: 200 }}>
                      <div style={styles.filterWrapper}>
                        <div style={styles.filterContainer}>
                          {orderedFilters.map((filter) => (
                            <AppliedFilter
                              key={filter.key}
                              filter={filter}
                              onRemove={onRemoveFilter}
                            />
                          ))}
                          {additionalFilters.map((filter) => (
                            <AppliedFilter
                              key={filter.key}
                              filter={filter}
                              onRemove={onRemoveFilter}
                            />
                          ))}
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                {/* Right: Reload + Back + Clear */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    flexWrap: "wrap",
                    flex: "0 0 auto",
                  }}
                >
                  {/* OLD: Download button was always visible once results are loaded */}
                  {/*
                  <MuiButton
                    onClick={onDownloadReport}
                    variant="outlined"
                    color="primary"
                    sx={{
                      textTransform: "none",
                      height: "32px",
                      fontSize: "13px",
                      padding: "0 14px",
                      minWidth: "140px",
                    }}
                    disabled={!searchData || !searchData.length}
                  >
                    Download Reports
                  </MuiButton>
                  */}

                  {!isCurrentMonthSelected() && (
                    <MuiButton
                      onClick={onDownloadReport}
                      variant="outlined"
                      color="primary"
                      sx={{
                        textTransform: "none",
                        height: "32px",
                        fontSize: "13px",
                        padding: "0 14px",
                        minWidth: "140px",
                      }}
                      disabled={!searchData || !searchData.length}
                    >
                      Download Reports
                    </MuiButton>
                  )}
                  <div style={styles.reload} onClick={onRefresh}>
                    <ReloadIcon />
                  </div>
                  <MuiButton
                    onClick={handleResetAndClose}
                    variant="outlined"
                    color="secondary"
                    sx={{
                      textTransform: "none",
                      height: "32px",
                      fontSize: "13px",
                      padding: "0 14px",
                      minWidth: "100px",
                    }}
                  >
                    Clear Filters
                  </MuiButton>
                  <MuiButton
                    onClick={handleGoBackToSearch}
                    variant="contained"
                    color="primary"
                    sx={{
                      textTransform: "none",
                      height: "32px",
                      fontSize: "13px",
                      padding: "0 14px",
                    }}
                  >
                    Back
                  </MuiButton>
                </div>
              </div>

              {/* Table */}
              <div style={{ flex: 1, overflowX: "auto", marginTop: "15px" }}>
                <ReportTable
                  searchData={searchData}
                  currentPage={currentPage}
                  pageSize={pageSize}
                  hasPermission={hasPermission}
                  appliedFilters={appliedFilters}
                />
              </div>
            </>
          ) : showSearchResult ? null : (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                padding: "30px 0",
                color: "#777",
              }}
            >
              <EmptyFileIcon width={100} />
              <span>No data found with current Filters</span>
            </div>
          )}
        </Modal>

        <Toast
          open={!!showToast}
          severity={showToast?.severity || ""}
          message={showToast?.message || ""}
          handleClose={() => setShowToast(null)}
        />
      </div>
    </>
  );
}

export default StatsReports;
